export default __webpack_public_path__ + "static/media/calconvert_background_m1.692d4fa3.jpg";